export interface IntervalOption {
  label: string;
  iconName: string;
}

export const intervals: Record<number, IntervalOption> = {
  1: { label: 'Iniciar Jornada', iconName: 'play_circle' },
  2: { label: 'Pausar', iconName: 'pause_circle' },
  3: { label: 'Reanudar', iconName: 'play_circle' },
  4: { label: 'Finalizar', iconName: 'stop_circle'}
};

export interface scheduleToMark {
  aIntervals?: intervals[]
  aAuscense?: detailAuscences[]
}

export interface Location {
  latitude: number | null;
  longitude: number | null;
  accuracy?: number | null;
  isSuccess?: boolean;
  sMessage?: string;
};

export interface intervals {
  oStart: detailIntervals,
  oEnd: detailIntervals,
}

export interface detailIntervals {
  dHour: Date;
  oRangos: {
    nRango_Maximo: number;
    nRango_Minimo: number;
    nTolerancia: number;
  };
}

export interface detailAuscences {
  dHora_Fin: Date 
  dHora_Ini: Date
  sDescription: string
}

export interface MarkCard {
    dTiempo_Marca:          string | null;
    dFecha_Marca:           string;
    nTipo_Marcacion:        number;
    sNombre_Tipo_Marcacion: string;
    nEstado_Marcacion:      number | null;
    nUsuario_Creador:       number | null;
    nUsuario_Update:        number | null;
    nMarcaje_Extemporaneo:  number | null;
    dFecha_Hora_Marca: string | null;
}

export interface IntervalState {
  id: string;
  isRunning: boolean;
  startTime: string;
  elapsedSeconds: number;
}

export interface responseIndexDBIntervals {
  aMarking_alowed: number[];
  dHora_Inicio: string | null;
  dHora_Salida: string | null;
  nDay: number;
  nDia: number;
  nId_Colaborador: number;
  nInterval: number;
  nRango_Maximo: number;
  nRango_Minimo: number;
  nTolerancia: number;
}


export interface response_getmarks {
  aIntervals: aIntervals[];
  dFecha_Jornada: string
}

export interface aIntervals {
  dDate: string;
  dFecha_Jornada: string;
  lat: number;
  lon: number;
  nInterval: number;
  nType_Mark: number;
  nMetodo_Marcaje: number;
  sMetodo_Marcaje: string;
  sIcono_Marcaje: string;
  bIs_Extemporanea: number;
  nId?: number;
}


export interface CollaboratorMarksResponse {
  nDay: number;
  nInterval: number;
  nId_Colaborador: number;
  nDia: number;
  dtime: string | null;
  nRango_Minimo: number;
  nRango_Maximo: number;
  nTolerancia: number;
  aMarking_alowed: number[];
}

export interface update_location_data {
  nId_Mark: number;
  oLocatio_mark: positions;
}

export interface positions {
  nlat: number | null;
  nlng: number | null;
}


